import {
  asConnectorApi,
  bomDataApi,
  bomUpdateApi,
  configurationApi,
  diMaApi,
  electronClientApi,
  geometryApi,
  idmmApi,
  kvsApi,
  materialInfoApi,
  megTemplateApi,
  partlistApi,
  projectApi,
  projectStructureApi,
  qaApi,
  subprojectApi,
  templateApi,
  tmmApi,
  triggerApi,
  userApi,
} from "@org-avp/avp-avengers-ui-shared-apis";
import {
  authoringSystemReducer,
  authoringSystemSliceName,
  blacklistViewOptionsReducer,
  blacklistViewOptionsSliceName,
  changeTmmEditorTarget,
  configurationManagerTabViewOptionsReducer,
  configurationManagerTabViewOptionsSliceName,
  detachedViewsReducer,
  detachedViewsSliceName,
  errorResponseMiddleware,
  errorResponseReducer,
  errorResponseSliceName,
  errorSuppressionReducer,
  errorSuppressionSliceName,
  geometryManagerOptionsReducer,
  geometryManagerOptionsSliceName,
  geometryViewOptionsReducer,
  geometryViewOptionsSliceName,
  idManagerViewOptionsReducer,
  idManagerViewOptionsSliceName,
  languageReducer,
  languageSliceName,
  layoutReducer,
  layoutSliceName,
  marketingDataDialogReducer,
  marketingDataDialogSliceName,
  materialInfoViewOptionsReducer,
  materialInfoViewOptionsSliceName,
  menuOptionsReducer,
  menuOptionsSliceName,
  oidcReducer,
  oidcSliceName,
  overlayReducer,
  overlaySliceName,
  partlistViewOptionsReducer,
  partlistViewOptionsSliceName,
  pendingGeometriesReducer,
  pendingGeometriesSliceName,
  posDataSelectionProjectStructureReducer,
  posDataSelectionProjectStructureSliceName,
  projectReducer,
  projectSliceName,
  samGeometryReducer,
  samGeometrySliceName,
  samKvsReducer,
  samKvsSearchSliceName,
  samMaterialInfoReducer,
  samMaterialInfoSliceName,
  samPartlistReducer,
  samPartlistSliceName,
  samProjectStructureReducer,
  samProjectStructureSliceName,
  samQaReducer,
  samQaSliceName,
  samRepresentationReducer,
  samRepresentationSliceName,
  samTemplateReducer,
  samTemplateSliceName,
  samTmmReducer,
  samTmmSliceName,
  setDetachedViewTimestamp,
  setGeometrySelection,
  setLanguageAction,
  setPartlistSelection,
  setPartlistSelectionRequest,
  setQaBasicProjectStructureFilter,
  setQaBasicTemplateFilter,
  setQaDictionaryProjectStructureFilter,
  setQaDictionaryTemplateFilter,
  setRepresentationSelection,
  setThemeAction,
  targetManagerViewOptionsReducer,
  targetManagerViewOptionsSliceName,
  themeSliceName,
  themeSliceReducer,
  tmmEditorReducer,
  tmmEditorSliceName,
  tmmEditorViewOptionsReducer,
  tmmEditorViewOptionsSliceName,
  tmmViewOptionsReducer,
  tmmViewOptionsSliceName,
  viewsToOpenReducer,
  viewsToOpenSliceName,
} from "@org-avp/avp-avengers-ui-shared-store";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createStateSyncMiddleware, initStateWithPrevTab, withReduxStateSync } from "redux-state-sync";

export const createStore = () => {
  const stateSyncWhitelist: string[] = [
    changeTmmEditorTarget.type,
    setDetachedViewTimestamp.type,
    setGeometrySelection.type,
    setLanguageAction.type,
    setPartlistSelection.type,
    setPartlistSelectionRequest.type,
    setQaBasicProjectStructureFilter.type,
    setQaBasicTemplateFilter.type,
    setQaDictionaryProjectStructureFilter.type,
    setQaDictionaryTemplateFilter.type,
    setRepresentationSelection.type,
    setThemeAction.type,
  ];

  const stateSyncMiddleware = createStateSyncMiddleware({
    prepareState: (state) => {
      const stateSyncWhitelistSliceNames = new Set(stateSyncWhitelist.map((val) => val.split("/")[0]));
      return Object.fromEntries(Object.entries(state).filter(([key]) => stateSyncWhitelistSliceNames.has(key)));
    },
    whitelist: stateSyncWhitelist,
  });

  const middlewareArray = [
    errorResponseMiddleware,
    stateSyncMiddleware,

    asConnectorApi.middleware,
    bomDataApi.middleware,
    bomUpdateApi.middleware,
    configurationApi.middleware,
    diMaApi.middleware,
    electronClientApi.middleware,
    geometryApi.middleware,
    idmmApi.middleware,
    kvsApi.middleware,
    materialInfoApi.middleware,
    megTemplateApi.middleware,
    partlistApi.middleware,
    projectApi.middleware,
    projectStructureApi.middleware,
    qaApi.middleware,
    subprojectApi.middleware,
    templateApi.middleware,
    tmmApi.middleware,
    triggerApi.middleware,
    userApi.middleware,
  ];

  const reducerLookup = {
    [asConnectorApi.reducerPath]: asConnectorApi.reducer,
    [bomDataApi.reducerPath]: bomDataApi.reducer,
    [bomUpdateApi.reducerPath]: bomUpdateApi.reducer,
    [configurationApi.reducerPath]: configurationApi.reducer,
    [diMaApi.reducerPath]: diMaApi.reducer,
    [electronClientApi.reducerPath]: electronClientApi.reducer,
    [geometryApi.reducerPath]: geometryApi.reducer,
    [idmmApi.reducerPath]: idmmApi.reducer,
    [kvsApi.reducerPath]: kvsApi.reducer,
    [materialInfoApi.reducerPath]: materialInfoApi.reducer,
    [megTemplateApi.reducerPath]: megTemplateApi.reducer,
    [partlistApi.reducerPath]: partlistApi.reducer,
    [projectApi.reducerPath]: projectApi.reducer,
    [projectStructureApi.reducerPath]: projectStructureApi.reducer,
    [qaApi.reducerPath]: qaApi.reducer,
    [subprojectApi.reducerPath]: subprojectApi.reducer,
    [templateApi.reducerPath]: templateApi.reducer,
    [tmmApi.reducerPath]: tmmApi.reducer,
    [triggerApi.reducerPath]: triggerApi.reducer,
    [userApi.reducerPath]: userApi.reducer,

    [samGeometrySliceName]: samGeometryReducer,
    [samKvsSearchSliceName]: samKvsReducer,
    [samMaterialInfoSliceName]: samMaterialInfoReducer,
    [samPartlistSliceName]: samPartlistReducer,
    [samProjectStructureSliceName]: samProjectStructureReducer,
    [samQaSliceName]: samQaReducer,
    [samRepresentationSliceName]: samRepresentationReducer,
    [samTemplateSliceName]: samTemplateReducer,
    [samTmmSliceName]: samTmmReducer,

    [marketingDataDialogSliceName]: marketingDataDialogReducer,

    [blacklistViewOptionsSliceName]: blacklistViewOptionsReducer,
    [configurationManagerTabViewOptionsSliceName]: configurationManagerTabViewOptionsReducer,
    [geometryManagerOptionsSliceName]: geometryManagerOptionsReducer,
    [geometryViewOptionsSliceName]: geometryViewOptionsReducer,
    [idManagerViewOptionsSliceName]: idManagerViewOptionsReducer,
    [materialInfoViewOptionsSliceName]: materialInfoViewOptionsReducer,
    [partlistViewOptionsSliceName]: partlistViewOptionsReducer,
    [targetManagerViewOptionsSliceName]: targetManagerViewOptionsReducer,
    [tmmEditorViewOptionsSliceName]: tmmEditorViewOptionsReducer,
    [tmmViewOptionsSliceName]: tmmViewOptionsReducer,

    [authoringSystemSliceName]: authoringSystemReducer,
    [detachedViewsSliceName]: detachedViewsReducer,
    [errorResponseSliceName]: errorResponseReducer,
    [errorSuppressionSliceName]: errorSuppressionReducer,
    [languageSliceName]: languageReducer,
    [layoutSliceName]: layoutReducer,
    [menuOptionsSliceName]: menuOptionsReducer,
    [oidcSliceName]: oidcReducer,
    [overlaySliceName]: overlayReducer,
    [pendingGeometriesSliceName]: pendingGeometriesReducer,
    [posDataSelectionProjectStructureSliceName]: posDataSelectionProjectStructureReducer,
    [projectSliceName]: projectReducer,
    [themeSliceName]: themeSliceReducer,
    [tmmEditorSliceName]: tmmEditorReducer,
    [viewsToOpenSliceName]: viewsToOpenReducer,
  };

  const store = configureStore({
    devTools: new URLSearchParams(window.location.search).has("enableDevTools"),
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
      ...middlewareArray,
    ],
    reducer: withReduxStateSync(
      combineReducers(reducerLookup),
      (prevState, nextState) => {
        return { ...prevState, ...nextState };
      },
    ),
  });

  initStateWithPrevTab(store);
  return store;
};
